import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gg-dashboard-icon',
  templateUrl: './dashboard-icon.component.html',
  styleUrl: './dashboard-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardIconComponent {

}
